import { render, staticRenderFns } from "./Remote2.vue?vue&type=template&id=1cf671e1&"
import script from "./Remote2.vue?vue&type=script&lang=js&"
export * from "./Remote2.vue?vue&type=script&lang=js&"
import style0 from "./Remote2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports